import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GlobalOutlined } from '@ant-design/icons';
import styles from './style.module.less';
const LocaleTag = ({ locale }) => (_jsxs("span", { className: styles.localeTag, children: [_jsx(GlobalOutlined, { className: styles.localeGlobe }), locale ? locale.lang.toUpperCase() : ''] }));
export default LocaleTag;
